// extracted by mini-css-extract-plugin
export default {"tabContainer":"StudentProfilePageTabs_tabContainer__feEgY","tabPill":"StudentProfilePageTabs_tabPill__7mMOa","activeTab":"StudentProfilePageTabs_activeTab__vtbKD"};